import { PlayerJoinEvent } from './player-join.event';
import { ChangeColourEvent } from './change-colour.event';
import { GameStartEvent } from './game-start.event';
import { PiecePlacedEvent } from './piece-placed.event';
import { TurnStartEvent } from './turn-start.event';
import { DiceRolledEvent } from './dice-rolled.event';
import { TradeOfferedEvent } from './trade-offered.event';
import { TradeAcceptedEvent } from './trade-accepted.event';
import { TradeCounteredEvent } from './trade-countered.event';
import { TradeConcludedEvent } from './trade-concluded.event';
import { TradeWithdrawnEvent } from './trade-withdrawn.event';
import { DiscardRequiredEvent } from './discard-required.event';
import { DiscardedEvent } from './discarded.event';
import { RobberRequiredEvent } from './robber-required.event';
import { RobberMovedEvent } from './robber-moved.event';
import { CardStolenEvent } from './card-stolen.event';
import { TurnResumedEvent } from './turn-resumed.event';
import { PieceBuiltEvent } from './piece-built.event';
import { DevelopmentCardBoughtEvent } from './development-card-bought.event';
import { BankTradedEvent } from './bank-traded.event';
import { KnightPlayedEvent } from './knight-played.event';
import { DevelopmentCardPlayedEvent } from './development-card-played.event';
import { MonopolyPlayedEvent } from './monopoly-played.event';
import { WinEvent } from './win.event';

export enum EventType {
  PlayerJoin = 'PlayerJoin',
  ChangeColour = 'ChangeColour',
  GameStart = 'GameStart',
  PiecePlaced = 'PiecePlaced',
  Reconnect = 'Reconnect',
  TurnStart = 'TurnStart',
  DiceRolled = 'DiceRolled',
  TradeOffered = 'TradeOffered',
  TradeAccepted = 'TradeAccepted',
  TradeCountered = 'TradeCountered',
  TradeConcluded = 'TradeConcluded',
  TradeWithdrawn = 'TradeWithdrawn',
  DiscardRequired = 'DiscardRequired',
  Discarded = 'Discarded',
  RobberRequired = 'RobberRequired',
  RobberMoved = 'RobberMoved',
  CardStolen = 'CardStolen',
  TurnResumed = 'TurnResumed',
  PieceBuilt = 'PieceBuilt',
  DevelopmentCardBought = 'DevelopmentCardBought',
  KnightPlayed = 'KnightPlayed',
  BankTraded = 'BankTraded',
  DevelopmentCardPlayed = 'DevelopmentCardPlayed',
  MonopolyPlayed = 'MonopolyPlayed',
  Win = 'Win',
}

export interface CatanEvent {
  eventType: EventType;
  gameId: string;
  lockState: number;
}

interface ReconnectEvent extends CatanEvent {
  eventType: EventType.Reconnect;
  data: {};
}

export type GameEvent =
  | ReconnectEvent
  | PlayerJoinEvent
  | ChangeColourEvent
  | GameStartEvent
  | PiecePlacedEvent
  | TurnStartEvent
  | DiceRolledEvent
  | TradeOfferedEvent
  | TradeAcceptedEvent
  | TradeCounteredEvent
  | TradeConcludedEvent
  | TradeWithdrawnEvent
  | DiscardRequiredEvent
  | DiscardedEvent
  | RobberRequiredEvent
  | RobberMovedEvent
  | CardStolenEvent
  | TurnResumedEvent
  | PieceBuiltEvent
  | DevelopmentCardBoughtEvent
  | BankTradedEvent
  | DevelopmentCardPlayedEvent
  | MonopolyPlayedEvent
  | KnightPlayedEvent
  | WinEvent;
